import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Link } from 'base-ui'

import { type PublicGlobalConfig } from '../../../../global-config'
import { urlResolverGetLinkToAllProductsOfSeller } from '../../../../url-handling'

export type CartIntermediateProductInfoSellerData = {
  sellerId: string
  sellerName: string
}

export const CartIntermediateProductInfoSellerLink: FC<{
  config: PublicGlobalConfig
  sellerData: CartIntermediateProductInfoSellerData
}> = ({ config, sellerData }) => {
  const { sellerId, sellerName } = sellerData

  return (
    <Link
      className="text-xs"
      href={urlResolverGetLinkToAllProductsOfSeller(config, sellerId)}
    >
      <FormattedMessage
        id="seller.products.allFromSeller"
        values={{ sellerName }}
      />
    </Link>
  )
}
